import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, TagsField } from 'components/Form'
import { PREDEFINED_AD_UNIT_SIZES } from 'features/globalSetup/features/viewport'
import { useAbility } from 'providers/casl'
import { Schema } from '../../../schema'

export const DefaultFields = (): React.JSX.Element => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.refresher.refreshRedirect.columns.refreshSizes.defaultFields',
  })
  const { control } = useFormContext<Schema>()
  const ability = useAbility()
  const cannotUpdateAdUnit = ability.cannot('update', 'AdUnit')

  return (
    <BoxForm>
      <TagsField
        control={control}
        disabled={cannotUpdateAdUnit}
        label={t('additionalSizes.label')}
        name='refreshRedirect.mediaTypeRefreshers.defaultAttribute.additionalSizes'
        options={PREDEFINED_AD_UNIT_SIZES}
        tooltip={{ content: t('additionalSizes.tooltip') }}
        width='lg'
      />

      <TagsField
        control={control}
        disabled={cannotUpdateAdUnit}
        label={t('removeSizes.label')}
        name='refreshRedirect.mediaTypeRefreshers.defaultAttribute.removeSizes'
        options={PREDEFINED_AD_UNIT_SIZES}
        tooltip={{ content: t('removeSizes.tooltip') }}
        width='lg'
      />
    </BoxForm>
  )
}
